import React from "react";
import { Typography, Container, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    position: "relative",
    marginTop: "8.8rem",
    marginBottom: "6.6rem",
  },
  media: {
    width: "100%",
    height: "100%",
  },
  textAlign: {
    marginTop: "2rem",
    [theme.breakpoints.down("md")]: {
      marginTop: "0",
    },
  },
  text: {
    position: "absolute",
    top: "47%",
    left: "-17.5%",
    transform: "translate(0, -50%)",
    width: "60%",
    [theme.breakpoints.down("md")]: {
      position: "static",
      top: "0%",
      left: "0%",
      transform: "translate(0, 0%)",
      width: "100%",
    },
  },
}));

const NeedTranslation = () => {
  const classes = useStyles();
  return (
    <Container maxWidth="md" className={classes.root}>
      <img
        alt="title"
        src="https://via.placeholder.com/1067x574?text=."
        className={classes.media}
      />
      <Container className={classes.text}>
        <Typography variant="h1" color="primary">
          Need Translation?
        </Typography>
        <Typography
          variant="h3"
          color="secondary"
          className={classes.textAlign}
        >
          NaTakallam offers professional translation and transcription services
          delivered by qualified refugees, overseen by certified copy editors,
          proofreaders and project managers.
        </Typography>
      </Container>
    </Container>
  );
};

export default NeedTranslation;
